var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2428_46436)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2428_46436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4373 8.61989L12.3093 16.7479C11.9988 17.0566 11.7527 17.4239 11.5852 17.8284C11.4177 18.233 11.332 18.6667 11.3333 19.1046V19.9999C11.3333 20.1767 11.4035 20.3463 11.5285 20.4713C11.6536 20.5963 11.8231 20.6666 11.9999 20.6666H12.8953C13.3331 20.6678 13.7668 20.5822 14.1714 20.4146C14.5759 20.2471 14.9432 20.001 15.2519 19.6906L23.3799 11.5626C23.7695 11.172 23.9883 10.6429 23.9883 10.0912C23.9883 9.53957 23.7695 9.01044 23.3799 8.61989C22.9837 8.24115 22.4567 8.02979 21.9086 8.02979C21.3605 8.02979 20.8335 8.24115 20.4373 8.61989ZM22.4373 10.6199L14.3093 18.7479C13.9333 19.1215 13.4253 19.3318 12.8953 19.3332H12.6666V19.1046C12.668 18.5745 12.8783 18.0665 13.2519 17.6906L21.3799 9.56255C21.5223 9.42652 21.7117 9.35061 21.9086 9.35061C22.1055 9.35061 22.2949 9.42652 22.4373 9.56255C22.5772 9.7029 22.6558 9.89301 22.6558 10.0912C22.6558 10.2894 22.5772 10.4795 22.4373 10.6199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 13.986C23.1565 13.986 22.987 14.0562 22.8619 14.1813C22.7369 14.3063 22.6667 14.4759 22.6667 14.6527V18H20C19.4696 18 18.9609 18.2107 18.5858 18.5858C18.2107 18.9609 18 19.4696 18 20V22.6667H11.3333C10.8029 22.6667 10.2942 22.456 9.91912 22.0809C9.54405 21.7058 9.33333 21.1971 9.33333 20.6667V11.3333C9.33333 10.8029 9.54405 10.2942 9.91912 9.91912C10.2942 9.54405 10.8029 9.33333 11.3333 9.33333H17.3613C17.5381 9.33333 17.7077 9.2631 17.8327 9.13807C17.9578 9.01305 18.028 8.84348 18.028 8.66667C18.028 8.48986 17.9578 8.32029 17.8327 8.19526C17.7077 8.07024 17.5381 8 17.3613 8H11.3333C10.4496 8.00106 9.60237 8.35259 8.97748 8.97748C8.35259 9.60237 8.00106 10.4496 8 11.3333L8 20.6667C8.00106 21.5504 8.35259 22.3976 8.97748 23.0225C9.60237 23.6474 10.4496 23.9989 11.3333 24H18.8953C19.3333 24.0013 19.7671 23.9156 20.1718 23.7481C20.5764 23.5806 20.9438 23.3345 21.2527 23.024L23.0233 21.252C23.3338 20.9432 23.58 20.576 23.7477 20.1715C23.9153 19.767 24.0011 19.3332 24 18.8953V14.6527C24 14.4759 23.9298 14.3063 23.8047 14.1813C23.6797 14.0562 23.5101 13.986 23.3333 13.986ZM20.31 22.0813C20.042 22.3487 19.7031 22.5337 19.3333 22.6147V20C19.3333 19.8232 19.4036 19.6536 19.5286 19.5286C19.6536 19.4036 19.8232 19.3333 20 19.3333H22.6167C22.5342 19.7023 22.3493 20.0406 22.0833 20.3093L20.31 22.0813Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2428_46436",
    x: -4,
    y: -4,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2428_46436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2428_46436",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2428_46436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCircle);
export default __webpack_public_path__ + "static/media/edit-circle.435dc58a8054fc687fa72645047e27fb.svg";
export { ForwardRef as ReactComponent };